import FieldProto from "../../proto/field-proto"
import FieldConfig from "../../proto/field-config"
import FieldMultiselectCheckbox_FormElement from "./render/form-element"

export default class FieldMultiselectCheckbox extends FieldProto {

    FIELD_DEFAULT_WIDTH = 100

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Multiselect checkbox"
        this.icon               = 'i5-checkbox'

        this.options            = _.get(config,'options',[])        // [{value, label},...]
        this.lockedValues       = _.get(config,'lockedValues',[])   // [value, ...]

        this.renderComponents.formElement = FieldMultiselectCheckbox_FormElement
    }
}
